import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, catchError, of } from 'rxjs';

import { IDjangoErrors } from '../../../models/DjangoErrors';
import { AnalyticalDatasetRequestService } from '../../../services/analytical-dataset-request.service';
import { AnalyticalDatasetRequestUiActions, AnalyticalDatasetRequestApiActions } from '../actions/index';
import { IAnalyticalDatasetRequest, IAnalyticalDatasetRequestDetail } from '../../../models/analytical-dataset-request';

@Injectable()
export class AnalyticalDatasetRequestEffects {
  private actions$ = inject(Actions);
  private analyticalDatasetRequestService = inject(AnalyticalDatasetRequestService);

  getAnalyticalDatasetRequests$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AnalyticalDatasetRequestUiActions.GetAnalyticalDatasetRequests),
      concatMap(() =>
        this.analyticalDatasetRequestService.getAnalyticalDatasetRequests().pipe(
          map((results: IAnalyticalDatasetRequest[]) =>
            AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestsSuccess({ payload: results })
          ),
          catchError((error) =>
            of(
              AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestsFailure({
                errors: error as IDjangoErrors,
              })
            )
          )
        )
      )
    )
  );

  getAnalyticalDatasetRequestDetail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AnalyticalDatasetRequestUiActions.GetAnalyticalDatasetRequestDetail),
      concatMap(({ id, scope }) =>
        this.analyticalDatasetRequestService.getAnalyticalDatasetRequestDetail(id, scope).pipe(
          map((result: IAnalyticalDatasetRequestDetail) =>
            AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestDetailSuccess({ payload: result })
          ),
          catchError((error) =>
            of(
              AnalyticalDatasetRequestApiActions.GetAnalyticalDatasetRequestDetailFailure({
                errors: error as IDjangoErrors,
              })
            )
          )
        )
      )
    )
  );
}
